/**
 * @file paddlejs
 * @author wanzhongyun
 */

import React from 'react';

import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import PaddleJSBanner from './components/paddleJSBanner/PaddleJsBanner';
import PaddleJSCore from './components/paddleJSCore/PaddleJSCore';
import PaddleJSOverview from './components/paddleJSOverview/PaddleJSOverview';
import PaddleJSOnline from './components/paddleJSOnline/PaddleJSOnline';
import PaddleJSImplement from './components/paddleJSImplement/PaddleJSImplement';
import PaddleJSModelService from './components/paddleJSModelService/PaddleJSModelService';
import PaddleJSCase from './components/paddleJSCase/PaddleJSCase';
import PaddleJSConsult from './components/paddleJSConsult/PaddleJSConsult';

import usePaddleJSHooks from './PaddleJSHooks';


const PaddleJS: React.FC = () => {

    const {
        paddleJsBanner,
        paddleJsCore,
        paddleJsOverview,
        paddleJsOnline,
        paddleJsImplement,
        paddleJsModelService,
        paddleJsCase,
        paddleJsConsult
    } = usePaddleJSHooks();

    return (
        <div>
            <Header />

            <div className="paddle-js-all-widget-wrapper">
                <PaddleJSBanner {...paddleJsBanner} />
                <PaddleJSCore {...paddleJsCore} />
                <PaddleJSOverview {...paddleJsOverview} />
                <PaddleJSOnline {...paddleJsOnline} />
                <PaddleJSImplement {...paddleJsImplement} />
                <PaddleJSModelService {...paddleJsModelService} />
                <PaddleJSCase {...paddleJsCase} />
                <PaddleJSConsult {...paddleJsConsult} />
            </div>

            <Footer /> 
        </div>
    );
};

export default React.memo(PaddleJS);
